import { parseStartTimeMs, formatTimeRemainingUntil } from "./studentRecentContent";

/** Join window after start_time. */
export const LIVE_JOIN_WINDOW_HOURS = 3;
export const LIVE_JOIN_WINDOW_MS = LIVE_JOIN_WINDOW_HOURS * 60 * 60 * 1000;

/**
 * @returns {'unscheduled'|'upcoming'|'open'|'ended'}
 */
export function getLiveSessionPhase(startTime, now = Date.now()) {
  const startMs = parseStartTimeMs(startTime);
  if (!startMs) return "unscheduled";
  if (now < startMs) return "upcoming";
  if (now > startMs + LIVE_JOIN_WINDOW_MS) return "ended";
  return "open";
}

export function getLiveJoinUrl(lv) {
  return (
    lv?.join_url ||
    lv?.url ||
    lv?.link ||
    lv?.zoom_link ||
    lv?.meeting_url ||
    null
  );
}

export function getLiveAttendanceId(lv) {
  return lv?.zoom_id ?? lv?.id ?? null;
}

/**
 * Whether the student can open the join link right now.
 * Respects active flag, join URL, upcoming start, and the join-window end.
 */
export function canJoinLiveSession(lv, now = Date.now()) {
  const join = getLiveJoinUrl(lv);
  if (!join) return false;
  if (Number(lv?.active) !== 1) return false;

  const phase = getLiveSessionPhase(lv?.start_time, now);
  if (phase === "upcoming" || phase === "ended") return false;
  return true;
}

export function getLiveSessionStatusLabel(lv, now = Date.now()) {
  const phase = getLiveSessionPhase(lv?.start_time, now);
  if (phase === "upcoming") return formatTimeRemainingUntil(lv?.start_time, now);
  if (phase === "ended") return "Live ended";
  return null;
}

export function getLiveJoinButtonLabel(lv, now = Date.now()) {
  const phase = getLiveSessionPhase(lv?.start_time, now);
  if (phase === "ended") return "Live ended";
  if (phase === "upcoming") {
    return formatTimeRemainingUntil(lv?.start_time, now) || "Starts soon";
  }
  return "Join now";
}
